/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardLimitRequestViewModel } from "../types/CreditCardLimitRequestViewModel.ts";

export const creditCardLimitRequestViewModelSchema = z.object({
  id: z.string().nullish(),
  token: z.string().nullish(),
  holderName: z.string().nullish(),
  number: z.string().nullish(),
  expMonth: z.string().nullish(),
  expYear: z.string().nullish(),
  cvv: z.string().nullish(),
  installments: z.optional(z.number().int()),
  recurrenceCycle: z.string().nullish(),
  recurrenceId: z.string().nullish(),
}) as unknown as ToZod<CreditCardLimitRequestViewModel>;
